// removed by extract-text-webpack-plugin
module.exports = {"geoContainer":"GeoDistribution-geoContainer"};